import axios from 'axios'
import request from './request';
import qs from 'qs'
import {showNotify} from "./getData";

// 注意点,按照以下写
let instance = axios.create();
instance.defaults.timeout = 10000;
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';


export function get(url, params = {}, isShowLoading = true, isShowError = true) {
  return new Promise((resolve, reject) => {
    request({
      url: url,
      method: 'get',
      data: qs.stringify(params),
      showLoading: isShowLoading
    }).then(res => {
      requestSuccessOpera(this, res, loading, isShowError, resolve, reject);
    }).catch(error => {
      requestFailOpera(this, error, loading, isShowError, reject);
    });
  })
}

export function post(url, params = {}, isShowLoading = true, isShowError = true) {
  // 解决方案二：使用qs模块(axios中自带),使用qs.stringify()序列化params
  return new Promise((resolve, reject) => {
    request({
      url: url,
      method: 'post',
      data: qs.stringify(params),
      showLoading: isShowLoading
    }).then(res => {
      requestSuccessOpera(this, res, isShowError, resolve, reject);
    }).catch(error => {
      requestFailOpera(this, error, isShowError, reject);
    });
  })
}

function requestSuccessOpera(that, res, isShowError, resolve, reject) {
  if (isShowError) {
    if (res.data.code === 200) {
      resolve(res.data);
    } else {
      let errorMsg = res.data.msg || that.$t('lang.serverErrorNotify');
      showNotify(that,errorMsg , "error");
      reject(errorMsg);
    }
  } else {
    resolve(res.data);
  }
}

function requestFailOpera(that, error, isShowError, reject) {
  if (isShowError) {
    showNotify(that, error, "error");
  }
  reject(error);
}

// 接口返回数据流导出excel
// 导出Excel公用方法
export function exportMethod(data, loading) {
  try {
    axios({
      method: 'post',
      url: `${this.baseUrl}${data.url}`,
      data: qs.stringify(data.params), // 参数
      responseType: 'blob'
    }).then((res) => {
      let fileReader = new FileReader();
      let _this = this;
      fileReader.readAsText(res.data);//读取流文件作为文本
      //文件读取完成之后执行
      fileReader.onload = function () {
        try {
          let jsonData = JSON.parse(this.result);
          if (jsonData.code) {
            showNotify(_this,jsonData.msg,"error");
          }
        } catch (err) {
          const link = document.createElement('a')
          let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = data.fileName //下载的文件名
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(link.href); // 释放URL 对象
          document.body.removeChild(link)
        }
      };
      if (loading) {
        loading.close();
      }
    }).catch(err => {
      if (loading) {
        loading.close();
      }
      showNotify(this,err.message,"error");
    })
  } catch (e) {
  }
}

//下架接口
export function underShelf(that, orderCode, codeType) {
  post( "sysCargoCode/underShelf", {
    token: that.localCache.msg.token,
    orderCode: orderCode,
    type: codeType,//0包裹码 1快递单号，2订单id ，3卡果号，4转运单号
    storeId: that.localCache.storage.id, //仓库id
  }, false, false).catch(error => {
    showNotify(that,`${that.$t('lang.failedToRemove')}：${error.msg || (error || that.$t('lang.serverErrorNotify'))}`,"error")
  });
}

/**
 * 直发下单面单
 * @param faceSheetType 1 下单面单 4 预报面单
 */
export function printingOrderForWebMulti(that, orderIds, index = -1, faceSheetType = 1) {
  return {
    url: `${that.baseUrl}sysWayBill/printingOrderForWebMulti?orderIds=${orderIds}&flightNumber=&faceSheetType=${faceSheetType}${index !== -1 ? ('&index=' + index) : ''}`,
    type: 'pdf'
  }
}

/**
 * 邮袋面单
 * @param that
 * @param orderId 订单的id
 * @param wayBillId 面单的id
 */
export function printMailBagWayBill(that, orderId, wayBillId) {
  return {
    url: `${that.baseUrl}sysWayBill/printMailBagWayBillPdf?mailBagId=${orderId}&wayBillId=${wayBillId}`,
    type: 'pdf'
  }; //拼袋
}

/**
 * 打包面单
 * @param orderId 订单的id
 * @param wayBillId 面单的id
 */
export function printingOrder(that, orderId, wayBillId) {
  return {
    url: `${that.baseUrl}sysWayBill/printingOrderPdf?orderId=${orderId}&wayBillId=${wayBillId}`,
    type: 'pdf'
  }; //拼袋
}

/**
 * 打印一维码
 * @param that
 * @param content 需要打印的内容
 */
export function getJBarcode(that, content) {
  return {
    url: `${that.baseUrl}system/getJBarcode?code=${content}`,
    type: 'image'
  }; //拼袋
}

/**
 * 打印一维码
 * @param that
 * @param content 需要打印的内容
 */
export function getJBarcodeDevice(that, content) {
  return {
    url: content,
    type: 'barcode'
  }; //拼袋
}

/**
 *通过会员号 搜索会员信息
 * @param memberNumber 会员号
 */
export function getMemberByMemberNumber(that, memberNumber) {
  return post(`user/getMemberByMemberNumber`, {
      memberNumber: memberNumber,
      storeId: that.localCache.storage.id
    }, false, false
  );
}




// WEBPACK FOOTER //
// ./src/api/api.js